import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Tab, Menu, Button, Dropdown, Embed } from 'semantic-ui-react';
import _findIndex from 'lodash/findIndex';
import { DEFAULT_FILE_LABEL, TYPE_PDF } from './MenuFilesDisplay.constants';
import { dropdownMenuFileOptionsMapping, getFileType } from './MenuFilesDisplay.utils';
import Image from '../../atoms/Image';
import './MenuFilesDisplay.css';
var defaultProps = {
  fileLabel: DEFAULT_FILE_LABEL
};
function MenuFilesDisplay(_ref) {
  var files = _ref.files,
    fileLabel = _ref.fileLabel;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var menuFileOptions = dropdownMenuFileOptionsMapping(files.map(function (_ref2, index) {
    var filename = _ref2.filename;
    return filename || "".concat(fileLabel, " ").concat(index + 1);
  }));
  function getTabPanes() {
    return files.map(function (_ref3, index) {
      var url = _ref3.url,
        filename = _ref3.filename;
      return {
        menuItem: /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("h3", null, filename || "".concat(fileLabel, " ").concat(index + 1))),
        pane: /*#__PURE__*/React.createElement(Tab.Pane, null, getFileType(url) !== TYPE_PDF && /*#__PURE__*/React.createElement(Image, {
          src: url,
          fluid: true
        }), getFileType(url) === TYPE_PDF && /*#__PURE__*/React.createElement(Embed, {
          url: url,
          active: true
        }))
      };
    });
  }
  function handleOptionsChange(options, key) {
    var index = _findIndex(options, {
      value: key
    });
    setActiveIndex(index);
  }
  var _files$activeIndex = files[activeIndex],
    url = _files$activeIndex.url,
    filename = _files$activeIndex.filename;
  return /*#__PURE__*/React.createElement("div", {
    className: "fm-menu-files-display"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop"
  }, /*#__PURE__*/React.createElement(Tab, {
    renderActiveOnly: false,
    menu: {
      style: {
        height: 'unset',
        overflowX: 'auto'
      },
      attached: true,
      tabular: true
    },
    panes: getTabPanes()
  })), /*#__PURE__*/React.createElement("div", {
    className: "mobile"
  }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(Dropdown, {
    options: menuFileOptions,
    onChange: function onChange(e) {
      return handleOptionsChange(menuFileOptions, e.target.textContent);
    },
    defaultValue: menuFileOptions[activeIndex].value,
    inline: true,
    scrolling: true
  })), /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: url,
    target: "_blank",
    primary: true,
    fluid: true
  }, "View ", filename || "Menu ".concat(activeIndex + 1))));
}
MenuFilesDisplay.defaultProps = defaultProps;
export default MenuFilesDisplay;